import React from "react";
import { ExternalLink } from "@thecb/components";
import { useFlags } from "launchdarkly-react-client-sdk";

import { INFO_BLUE, INFO_BLUE_LIGHT } from "../../constants/colors";

/**
 * A simple component that generates a version label based on variables injected during the build
 * process. The `process.env.*` variables are defined in `webpack.config.js` and injected when
 * Webpack builds the app. Because the CI is what injects the git SHA, it will not be available
 * when running the app locally.
 */
const VersionLabel = ({
  gitSHA = process.env.GIT_SHA_SHORT || "",
  labelLink = process.env.GIT_COMMIT_LINK || "",
}) => {
  const localLabel = "LOCAL DEVELOPMENT";
  const displayedLabel = gitSHA || localLabel;

  // Get Launch Darkly version tag feature flag from Launch Darkly.
  // This tag is intended to safely test Revm LD behavior in prod.
  const useLDVersionTag = useFlags()?.["display-ld-version-tag-rev-m"];
  const LDLabelTag = useLDVersionTag ? "LD " : "";

  const linkedVersionLabel = (
    <>
      Version {LDLabelTag}
      <ExternalLink
        newTab
        href={labelLink}
        extraStyles={`
          display: inline-block;

          // This nesting is only here because "src/styles/_overwrite.scss => a:not(.btn)"
          // will otherwise take precedence over the color styling.
          &:not(.btn) {
            color: ${INFO_BLUE};
            &:hover { color: ${INFO_BLUE_LIGHT} }
          }
        `}
      >
        {displayedLabel}
      </ExternalLink>
    </>
  );

  const unlinkedVersionLabel =
    displayedLabel !== localLabel ? (
      <>
        Version {LDLabelTag}
        {displayedLabel}
      </>
    ) : (
      <>{displayedLabel}</>
    );

  return gitSHA && labelLink ? linkedVersionLabel : unlinkedVersionLabel;
};

export default VersionLabel;
